import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="campaign-search"
export default class extends Controller {
  static targets = ["input", "clearButton"];

  clear() {
    this.inputTarget.value = "";
    this.clearButtonTarget.classList.add("hidden");
  }

  connect() {
    this.timeout = null;
    this.delay = 400; // Debounce delay in milliseconds

    this.inputTarget.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault(); // Prevent form submission on Enter
      }
    });
  }

  performSearch() {
    // Get the form element and submit it
    const form = this.inputTarget.closest("form");
    if (form) {
      this.timeout = null; // Clear the timeout to prevent multiple submissions
      form.requestSubmit();
    }
  }

  search(e) {
    if (e.currentTarget.value.trim() === "") {
      this.clearButtonTarget.classList.add("hidden");
    } else {
      this.clearButtonTarget.classList.remove("hidden");
    }

    // Clear the previous timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Set a new timeout to execute the search after the delay
    this.timeout = setTimeout(() => {
      this.performSearch();
    }, this.delay);
  }
}
